import styled from 'styled-components';

const StyledContainer = styled.div`
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	width: 460px;
	padding: 30px;
	background-color: #111314;
	border-radius: 10px;
	opacity: 0;
	border: 1px solid rgba(255, 255, 255, 0.1);
	transition: opacity 0.5s ease 0.1s;
`;

const StyledCarPreviewContainer = styled.div`
	margin-top: 30px;
`;

const StyledComponentContainer = styled.div`
	margin-top: 20px;
`;

export { StyledCarPreviewContainer, StyledComponentContainer, StyledContainer };
